import Header from "components/Common/Header/Header";
import React, { useEffect } from "react";
import InventoryListBody from "components/ClinicalManagement/Inventory/InventoryListBody";

const Inventory = () => {
  useEffect(() => {
    document.title = "Inventory Module";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="clinicalmanagement" />
      <InventoryListBody />
    </main>
  );
};

export default Inventory;
